import dayjs, { Dayjs } from "dayjs";
import { DayHoursList } from "src/business/restaurant/restaurant";
import { PublicDeal } from "src/data/clientBooking/queries/clientBooking";

const today = dayjs();

export const getSelectableDates = (
  schedule: DayHoursList,
  leaves: string[],
): string[] => {
  const result: string[] = [];
  const scheduleDays = schedule.map((h) => h.day.toUpperCase());

  for (let i = 0; i < 30; i++) {
    const date = today.add(i, "day");
    const dayName = date.format("dddd").toUpperCase();
    const dateStr = date.format("YYYY-MM-DD");
    if (scheduleDays.includes(dayName) && !leaves.includes(dateStr)) {
      result.push(dateStr);
    }
  }
  return result;
};

export const getTimeSlotsForDay = (
  schedule: DayHoursList,
  selectedDay: Dayjs,
  bookingDuration: number,
): { morning: string[]; evening: string[] } => {
  const dayName = selectedDay.format("dddd").toUpperCase();
  const entry = schedule.find((h) => h.day.toUpperCase() === dayName);
  if (!entry) return { morning: [], evening: [] };

  const buildSlots = (start: Dayjs, end: Dayjs): string[] => {
    const result: string[] = [];
    let cur = start;
    while (cur.isBefore(end)) {
      result.push(cur.format("HH:mm"));
      cur = cur.add(bookingDuration, "minute");
    }
    return result;
  };

  return {
    morning: buildSlots(entry.morning.start, entry.morning.end),
    evening: entry.evening
      ? buildSlots(entry.evening.start, entry.evening.end)
      : [],
  };
};

export const getDealForSlot = (
  time: string,
  deals: PublicDeal[],
): PublicDeal | null => {
  const [h, m] = time.split(":").map(Number);
  const slotMin = h * 60 + m;

  for (const deal of deals) {
    const [sh, sm] = deal.startTime.split(":").map(Number);
    const [eh, em] = deal.endTime.split(":").map(Number);
    if (slotMin >= sh * 60 + sm && slotMin < eh * 60 + em) {
      return deal;
    }
  }
  return null;
};

export const formatTime12h = (time24: string): string => {
  const [h, m] = time24.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 || 12;
  return `${h12}:${m.toString().padStart(2, "0")} ${period}`;
};
